import React, { useEffect, useState } from 'react';

import * as S from '../styles';

import UploadFileIcon from '@mui/icons-material/UploadFile';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DownloadIcon from '@mui/icons-material/Download';
import FieldFormik from '../../../../../../../../components/newStudent/FieldFormik';
import { IDocumentsDegree } from '../../../../..';
import { FaCheck } from 'react-icons/fa';
import { useTheme } from 'styled-components';
import {
  typeDocComplementary,
  typeDocInternship,
} from '../../../../../../../../variables';
import {
  complementaryActivityTypeSelectOptions,
  internshipDocumentTypeSelectOptions,
} from '../../../../../../../../constants/universityDegreePortfolio';

interface Props {
  item: IDocumentsDegree;
  handleSave: (item: IDocumentsDegree, isOld?: boolean) => void;
  handleDelete: (id: number | string, isOld?: boolean) => void;
  isOld?: boolean;
  readOnly?: boolean;
  documentDegreeType: number;
}
export default function ItemDegree({
  item,
  handleDelete,
  handleSave,
  isOld,
  readOnly = false,
  documentDegreeType,
}: Props) {
  const [dataItem, setDataItem] = useState<IDocumentsDegree>(item);

  useEffect(() => {
    setDataItem(item);
  }, [item]);
  const theme = useTheme();
  return (
    <S.CardContent>
      <S.KeyValue>
        <S.H5
          style={{
            textAlign: 'center',
            width: '100%',
          }}
        >
          {item.name}
        </S.H5>
        <S.Div>
          {readOnly ? (
            <>
              {item.url ? (
                <a
                  href={item.url}
                  target="_blank"
                  rel="noreferrer"
                  title="Baixar"
                  style={{ display: 'inline-flex', alignItems: 'center' }}
                >
                  <DownloadIcon fontSize="large" />
                </a>
              ) : null}
              <FaCheck color={theme?.colors?.success} />
            </>
          ) : (
            <>
              {JSON.stringify(dataItem) !== JSON.stringify(item) && (
                <S.ButtonSave onClick={() => handleSave(dataItem, isOld)}>
                  <UploadFileIcon fontSize="large" />
                </S.ButtonSave>
              )}
              {(isOld && !dataItem.checked) || !isOld ? (
                <S.BtnDanger onClick={() => handleDelete(dataItem.id, isOld)}>
                  <DeleteForeverIcon fontSize="large" color="error" />
                </S.BtnDanger>
              ) : (
                <FaCheck color={theme?.colors?.success} />
              )}
            </>
          )}
        </S.Div>
      </S.KeyValue>
      <S.KeyValue>
        <S.Key>Data Início: </S.Key>
        <FieldFormik
          name="startDate"
          onChange={({ target }) =>
            setDataItem((old) => ({ ...old, startDate: target.value }))
          }
          type="date"
          value={dataItem.startDate}
          disabled={item.checked || readOnly}
        />
      </S.KeyValue>
      <S.KeyValue>
        <S.Key>Data fim: </S.Key>
        <FieldFormik
          name="endDate"
          onChange={({ target }) =>
            setDataItem((old) => ({ ...old, endDate: target.value }))
          }
          type="date"
          value={dataItem.endDate}
          disabled={item.checked || readOnly}
        />
      </S.KeyValue>
      <S.KeyValue>
        <S.Key>Carga Horária: </S.Key>
        <FieldFormik
          name="workload"
          onChange={({ target }) =>
            setDataItem((old) => ({ ...old, workload: target.value }))
          }
          type="number"
          value={dataItem.workload}
          disabled={item.checked || readOnly}
        />
      </S.KeyValue>
      <S.KeyValue>
        <S.Key>Descrição / Nome do Curso: </S.Key>
        <FieldFormik
          name="description"
          onChange={({ target }) =>
            setDataItem((old) => ({ ...old, description: target.value }))
          }
          type="string"
          value={dataItem.description}
          disabled={item.checked || readOnly}
        />
      </S.KeyValue>
      {documentDegreeType === +typeDocComplementary! && (
        <S.KeyValue>
          <S.Key>Tipo de Atividade: </S.Key>
          <FieldFormik
            name="typeActivity"
            onChange={({ target }) =>
              setDataItem((old) => ({ ...old, typeActivity: target.value }))
            }
            type="select"
            value={dataItem.typeActivity}
            options={complementaryActivityTypeSelectOptions}
            disabled={item.checked || readOnly}
          />
        </S.KeyValue>
      )}
      {documentDegreeType === +typeDocInternship! && (
        <S.KeyValue>
          <S.Key>Tipo de documento do estágio: </S.Key>
          <FieldFormik
            name="typeActivity"
            onChange={({ target }) =>
              setDataItem((old) => ({ ...old, typeActivity: target.value }))
            }
            type="select"
            value={dataItem.typeActivity}
            options={internshipDocumentTypeSelectOptions}
            disabled={item.checked || readOnly}
          />
        </S.KeyValue>
      )}
    </S.CardContent>
  );
}
